import React from 'react'
import { ReactComponent as Loader } from 'assets/images/universal_search_loader.svg'

import styles from './LoadingSearchList.module.css'

export const LoadingSearchList: React.FC = () => {
  return (
    <div className={styles.searchingWrapper}>
      <div className={styles.searchingHeader}>Searching . . </div>
      {[...Array(4)].map(each => (
        <Loader key={each} />
      ))}
    </div>
  )
}
